import * as React from 'react';
import {
    View,
    Text,
    Image,
    TouchableOpacity,
    ScrollView,
    StyleSheet
} from 'react-native';
import Config from '../../constants/Config';
import Colors from '../../constants/Colors'
import FontStyles from '../../constants/FontStyle';

const ManufacturerSaleOfficer = function ({list, commitSeller}) {

    const ManufacturerSaleOfficerStack = () => {
        return list.map(item => {
            // if (item.status === 'inactive' || item.role !== 'rep') {
            //     return null
            // }
            return (
                <TouchableOpacity key={item._id} style={styles.itemWrapper} onPress={() => {commitSeller(item)}}>
                    <View style={styles.itemCard}>
                        <Image source={{ uri: `${Config.uploadUrl}${item.upload.path}` }} style={{ width: 78, height: 78, borderRadius: 39 }} />
                        <Text style={{ textAlign: 'center', width: 78, height: 16, marginTop: 9 }} numberOfLines={1}>{item.name}</Text>
                    </View>
                </TouchableOpacity>
            )
        })
    }

    const DisplayStack = () => {
        if(list.length > 0) {
            return <ManufacturerSaleOfficerStack />
        }
        return null
    }

    return (
        <ScrollView contentContainerStyle={{
            paddingLeft: 16,
            paddingRight: 8,
        }}>
            {/* <View style={styles.listMenu}>
                <Text style={styles.listMenuText}>Manufacturers</Text>
            </View> */}

            <View style={styles.listWrapper}>

                {list.length > 0
                    ? <DisplayStack />
                    : (
                        <>
                            <View style={styles.itemWrapper}>
                                <View style={styles.itemCard}>
                                    <View style={{ backgroundColor: '#FFFFFF', width: 78, height: 78, borderRadius: 39 }}></View>
                                    <View style={{ backgroundColor: '#FAFAFA', width: 50, height: 16, marginTop: 9 }}></View>
                                </View>
                            </View>
                            <View style={styles.itemWrapper}>
                                <View style={styles.itemCard}>
                                    <View style={{ backgroundColor: '#FFFFFF', width: 78, height: 78, borderRadius: 39 }}></View>
                                    <View style={{ backgroundColor: '#FAFAFA', width: 50, height: 16, marginTop: 9 }}></View>
                                </View>
                            </View>
                            <View style={styles.itemWrapper}>
                                <View style={styles.itemCard}>
                                    <View style={{ backgroundColor: '#FFFFFF', width: 78, height: 78, borderRadius: 39 }}></View>
                                    <View style={{ backgroundColor: '#FAFAFA', width: 50, height: 16, marginTop: 9 }}></View>
                                </View>
                            </View>
                        </>
                    ) 
    }

            </View>
        </ScrollView>
    )
}

export default ManufacturerSaleOfficer;



const styles = StyleSheet.create({
    listMenu: {
        marginRight: 8,
        height: 53,
        flexDirection: 'row'
    },
    listMenuText: {
        alignSelf: 'center',
        flexGrow: 1,
        width: 122,
        color: Colors.shades._7,
        ...FontStyles.size13,
        ...FontStyles.lh13,
        ...FontStyles.normal,
    },
    listWrapper: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 20,
    },
    itemWrapper: {
        width: '33.3333%',
        paddingRight: 8,
        marginBottom: 8,
    },
    itemCard: {
        marginBottom: 32,
        alignItems: 'center',
    }
})